export const GET_ALL_CONNECTION = "GET_ALL_CONNECTION";
export const GET_ALL_CONNECTION_SUCCESS = "GET_ALL_CONNECTION_SUCCESS";
export const ADD_CONNECTION_ITEM = "ADD_CONNECTION_ITEM";
export const DELETE_CONNECTION_ITEM = "DELETE_CONNECTION_ITEM";
export const GET_ALL_CONNECTION_CATEGORY = "GET_ALL_CONNECTION_CATEGORY";
export const CONNECTION_CATEGORY_ADD_ITEM = "CONNECTION_CATEGORY_ADD_ITEM";
export const CONNECTION_CATEGORY_DELETE = "CONNECTION_CATEGORY_DELETE";
export const CONNECTION_CATEGORY_UPDATE = "CONNECTION_CATEGORY_UPDATE";
export const GET_ALL_CONNECTION_FAILED = "GET_ALL_CONNECTION_FAILED";